import { Component, EventEmitter, Output } from '@angular/core';
import { CustomerAccountBusinessLogicService } from 'src/app/services/customer-account-business-logic.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from '../../../models/Constants';
import { ApiService } from 'src/app/services/api.service';
import { CallCustomerAttributes } from 'src/app/models/customer.model';
import { LogService } from 'src/app/services/log.service';
import { TbaDomainSelectionComponent } from "../../../components/customerAccounts/tba-domain-selection/tba-domain-selection.component";
import { MatDialog } from '@angular/material/dialog';
import { CustomerAlertsService } from 'src/app/services/customer-alerts.service';
import _ from 'lodash';

@Component({
  selector: 'app-approved-exception',
  templateUrl: './approved-exception.component.html',
  styleUrls: ['./approved-exception.component.scss'],
})
export class ApprovedExceptionComponent {

  @Output()
  changeCustomerTypeEmitter: EventEmitter<any> = new EventEmitter();
  @Output() goToCustomerOveriew: EventEmitter<any> = new EventEmitter();
  errorMsg = Constants.CUSTOMER_TYPE_FAILURE_MSG;
  credentialErrorMsg = Constants.APPROVED_EXCEPTION_CREDENTIAL_CONFIG_MISS_MSG;
  approvedExceptionNotSelected = Constants.APPROVEED_EXCEPTION_NOT_SELECTED_MSG;
  egainContentErrorMsg = Constants.APPROVED_EXCEPTION_EGAIN_CONTENT_CONFIG_MISS_MSG;
  resourceErrorMsg = Constants.RESOURCE_LINKS_CONFIG_MISS_MSG;
  orText = Constants.APPROVED_CREDS.OR_TEXT;
  dependentInfo = Constants.APPROVED_CREDS.DEPENDENT_INFO;
  noDataMsg = Constants.DATA_NOT_AVAIL_UI;
  className: string = "approved-exception";

  // Sample data for CCR1-10277 Person Internal Id table
  samplePersonInternalIdData = [
    { platformType: 'TBA_4X', domain: 'DB', personInternalId: '123456' },
    { platformType: 'TBA_4X', domain: 'DC', personInternalId: '789012' },
    { platformType: 'TBA_4X', domain: 'HM', personInternalId: '345678' }
  ];
  displayPlatformInternalIdTable: boolean = false;
  platformTypeData: any[] = [];

  constructor(
    public rootScope: RootScopeService, public dialog: MatDialog, public customerAlertService: CustomerAlertsService,
    public customerAccountService: CustomerAccountBusinessLogicService, public apiService: ApiService,public logger:LogService) { }


  changeCustomerType(event: any) {
    this.changeCustomerTypeEmitter.emit(event);

    this.rootScope.activeCustTab.approvedExceptionToggleValue = false;
    this.rootScope.activeCustTab.approvedExceptionSuccessMsg = false;
    this.rootScope.activeCustTab.isApprovedExceptionContinueDisabled = true;
    this.rootScope.activeCustTab.isApprovedExceptionContinueClicked = false;
    this.rootScope.activeCustTab.platformTypeTableData.displayPlatformInternalIdTable = false;
    this.logger.debugLogs("Customer Type Changed in ApprovedException for customerSessionId: "+this.rootScope.activeCustTab.customerSessionId, this.className);
  }

  /**
   * @author - Sultan Khan
  * Fetches exception and sub-exception data for the active customer tab's type.
  * This method initiates the retrieval of exception and sub-exception data by calling
  * the `getApprovedExceptionsListbyClientId` method from the `customerAccountService`
  */
  getExceptionandSubExceptionType() {
     this.customerAccountService.getApprovedExceptionsListByClientId(this.rootScope.activeCustTab.customerType,false);
  }

  /**
  * @author - Sultan Khan
 * Handles the change of the selected exception type and updates associated data.
 * This method is triggered when a new exception type is selected. It updates the
 * selected exception type in the active customer tab, clears the selected sub-exception,
 * resets the sub-exceptions list, and updates the form with an empty sub-type value.
 * It also populates the sub-exceptions list based on the selected exception type, if available.
 * 
 * @param event The event containing the newly selected exception type.
 */
  changeExceptionType(event: any) {
    this.rootScope.activeCustTab.approvedExceptionsTypes.selectedException = event?.value;
    this.rootScope.activeCustTab.approvedExceptionsTypes.selectedSubException = '';
    this.rootScope.activeCustTab.approvedExceptionCredentialData.CredentialDataAPIConfigMiss = false;
    this.rootScope.activeCustTab.approvedExceptionCredentialData.CredentialDataAPIFailure = false;
    this.rootScope.activeCustTab.approvedExceptionEgainContentData.EgainContentConfigMiss = false;
    this.rootScope.activeCustTab.approvedExceptionEgainContentData.EgainContentAPIFailure = false;
    this.rootScope.subExceptionsList = [];
    this.rootScope.activeCustTab.approvedExceptionCredentialData.selectedCredentialData = [];
    this.rootScope.activeCustTab.approvedExceptionEgainContentData.selectedEgainContent = '';
    this.rootScope.activeCustTab.approvedExceptionResouceLinksData.selectedResourceLinksData = [];
    this.rootScope.activeCustTab.approvedExceptionResouceLinksData.resourceLinksAPIFailure = false;
    this.rootScope.activeCustTab.approvedExceptionResouceLinksData.resourceLinksConfigMiss = false;
    const customerTypeFilterData = this.rootScope.activeCustTab.approvedExceptionsTypes
      .find((x: any) => x.exceptionsData?.customerType == this.rootScope.activeCustTab.customerType);

    if (customerTypeFilterData) {
      const exceptionFilterData = customerTypeFilterData.exceptionsData.exceptions
        .find((x: any) => x.exception_description == event?.value);
      this.rootScope.subExceptionsList = exceptionFilterData?.exception_subtypes;
    }
    this.rootScope.approvedTypeExceptionForm.patchValue({ subType: '' });

    this.rootScope.activeCustTab.approvedExceptionToggleValue = false;
    this.rootScope.activeCustTab.approvedExceptionSuccessMsg = false;
    this.rootScope.activeCustTab.isApprovedExceptionContinueDisabled = true;
    this.rootScope.activeCustTab.isApprovedExceptionContinueClicked = false;
    this.rootScope.activeCustTab.platformTypeTableData.displayPlatformInternalIdTable = false;

    this.logger.debugLogs("Approved Exception Type Changed for customerSessionId: "+this.rootScope.activeCustTab.customerSessionId, this.className);


  }

  /**
 * Handles the change of the selected sub-exception type within the active customer tab.
 * This method is triggered when a new sub-exception type is selected, and it updates the
 * selected sub-exception type in the active customer tab based on the provided event.
 * @param event The event containing the newly selected sub-exception type.
 */
  changeSubExceptionType(event: any): void {
    this.rootScope.activeCustTab.approvedExceptionsTypes.selectedSubException = event?.value;
    const selectedSubExceptionData = this.rootScope.subExceptionsList.find(x => x.exception_subtype_description == event?.value);
    this.customerAccountService.getCredetialData(selectedSubExceptionData);
    this.customerAccountService.getEgainContentData(selectedSubExceptionData);
    this.customerAccountService.getResourseLinks(selectedSubExceptionData);
    this.rootScope.activeCustTab.approvedExceptionToggleValue = false;
    this.rootScope.activeCustTab.approvedExceptionSuccessMsg = false;   
    this.rootScope.activeCustTab.isApprovedExceptionContinueDisabled = true;
    this.rootScope.activeCustTab.isApprovedExceptionContinueClicked = false;
    this.rootScope.activeCustTab.platformTypeTableData.displayPlatformInternalIdTable = false;
    this.rootScope.is_SecuredMap.set(this.rootScope.activeCustTab?.customerSessionId, selectedSubExceptionData?.is_secured);

    if(this.rootScope.healthCardApprovedExceptionList.includes(selectedSubExceptionData?.exception_subtype)){
      this.customerAccountService.getHealthCoverageDataForApprovedException();
    }

    
    
    this.logger.debugLogs("Approved Exception Sub Type Changed for customerSessionId: "+this.rootScope.activeCustTab.customerSessionId, this.className);
  }

  /**
   * Retrieves credential data for the selected sub-exception.
   */
  getCredetialData() {
    const selectedSubExceptionData = this.rootScope.subExceptionsList.find(x => x.exception_subtype == this.rootScope.activeCustTab.approvedExceptionsTypes.selectedSubException);
    this.customerAccountService.getCredetialData(selectedSubExceptionData);
    this.logger.debugLogs("Approved Exception Credential Data fetched for customerSessionId: "+this.rootScope.activeCustTab.customerSessionId, this.className);
  }

  /**
 * Retrieves Egain data for the selected sub-exception.
 */
  getEgainContentData() {
    const selectedSubExceptionData = this.rootScope.subExceptionsList.find(x => x.exception_subtype == this.rootScope.activeCustTab.approvedExceptionsTypes.selectedSubException);
    this.customerAccountService.getEgainContentData(selectedSubExceptionData);
    this.logger.debugLogs("Approved Exception Egain Content Data fetched for customerSessionId: "+this.rootScope.activeCustTab.customerSessionId, this.className);
  }

  /**
* Retrieves Resource Links data for the selected sub-exception.
*/
  getResourceLinksData() {
    const selectedSubExceptionData = this.rootScope.subExceptionsList.find(x => x.exception_subtype == this.rootScope.activeCustTab.approvedExceptionsTypes.selectedSubException);
    this.customerAccountService.getResourseLinks(selectedSubExceptionData);
  }

  onToggleChange(event: any) {
    // alert('Toggle value '+event?.checked  + 'Appro'+ this.rootScope.activeCustTab.isContinueButtonDisabled) ;

   if (event?.detail?.isOn) {
      this.rootScope.activeCustTab.isApprovedExceptionContinueDisabled = false;
      this.rootScope.activeCustTab.approvedExceptionSuccessMsg = true;
      this.rootScope.activeCustTab.approvedExceptionToggleValue=true;
      
    }
    else {
      this.rootScope.activeCustTab.isApprovedExceptionContinueDisabled = true;
       this.rootScope.activeCustTab.approvedExceptionToggleValue=false;
      this.rootScope.activeCustTab.approvedExceptionSuccessMsg = false;
      this.rootScope.activeCustTab.isApprovedExceptionContinueClicked = false;

    }
      this.createDataForPlatformInternalIdTable();
  }

  createDataForPlatformInternalIdTable(){
    this.rootScope.activeCustTab.platformTypeTableData.platformTypeData = [];
    const idMappingArr = this.rootScope.activeCustTab.tabData.tabData?.idMapping;
    let platformTypeConfiguredList = this.rootScope.platformTypeList;

    let that = this;
    idMappingArr?.map((each) => {
     if(platformTypeConfiguredList?.includes(each?.platformType)) {
          that.rootScope.activeCustTab.platformTypeTableData.platformTypeData.push(each);
        }
      })
  }

  /**CCR1-10898 ***/
  showRoleTypeInFullForm(roleType){
    if(this.rootScope.roleTypeListForPlatFormInternalIdTable[roleType]){
        return this.rootScope.roleTypeListForPlatFormInternalIdTable[roleType];
    }
    return roleType;
  }

  checkApprovedExceptionContinue() {
    return this.rootScope.activeCustTab.isApprovedExceptionContinueDisabled;
  }

  resetApprovedExceptionPage() {
    this.customerAccountService.getExceptionandSubException();
    this.rootScope.activeCustTab.approvedExceptionToggleValue = false;
    this.rootScope.activeCustTab.approvedExceptionSuccessMsg = false;
    this.rootScope.activeCustTab.isApprovedExceptionContinueDisabled = true;
    this.rootScope.activeCustTab.isApprovedExceptionContinueClicked = false;
    this.rootScope.activeCustTab.platformTypeTableData.displayPlatformInternalIdTable = false;
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.logger.debugLogs("Approved Exception Page Reset for customerSessionId: "+this.rootScope.activeCustTab.customerSessionId, this.className);

  }

  isLiveInteraction() {
    if (this.rootScope.activeCustTab.activeCall || this.rootScope.activeCustTab.activeChat) {
      return true;
    }
    else {
      this.rootScope.activeCustTab.approvedExceptionToggleValue = false;
      this.rootScope.activeCustTab.approvedExceptionSuccessMsg = false;
      this.rootScope.activeCustTab.isApprovedExceptionContinueDisabled = true;
      this.rootScope.activeCustTab.isApprovedExceptionContinueClicked = false;
      this.rootScope.activeCustTab.platformTypeTableData.displayPlatformInternalIdTable = false;

      return false;
    }
  }

  /**
   * Determines whether a link should be enabled based on the provided menu item.
   * @param {any} menu - The menu item to check for link enablement.
   * @returns {boolean} - Returns `true` if the link should be enabled; otherwise, returns `false`.
   */
  enableLink(menu: any): boolean {
    if (menu?.heading === Constants.TBA_KC_ARTICLES_LINKS_TYPES.TBA_EVENTS || menu?.heading === Constants.TBA_KC_ARTICLES_LINKS_TYPES.TBA_INQUIRIES) {
      return !this.rootScope.activeCustTab.isApprovedExceptionContinueClicked;
    }
    return false;
  }
 
openDomainSelector(menu) {
  this.dialog.open(TbaDomainSelectionComponent, {
    data:menu,
    panelClass: 'domain-selector',
    backdropClass: 'custom-overlay',
    disableClose: true,
    id: 'domainSelector'
  });
  this.logger.debugLogs("TBA Domain Selector opened for customerSessionId: "+this.rootScope.activeCustTab.customerSessionId, this.className);
}

  /**
   * 
   *  when user click on Continue button check isscure value and update in Genesys and store IH data in Tab level
   * @param 
   */
  actionsOnContinue() {
    this.rootScope.activeCustTab.isApprovedExceptionContinueClicked = true;
    this.rootScope.activeCustTab.approvedExceptionSuccessMsg = false;
    
    let approvedDetails = this.rootScope.activeCustTab?.approvedExceptionsTypes;
    
    


    // check weather approved expection varible is created in Tab model or not
    if (!(this.rootScope.activeCustTab['approvedExceptionIH'] instanceof Map)) this.rootScope.activeCustTab['approvedExceptionIH'] = new Map();
    this.rootScope.activeCustTab['approvedExceptionIH']?.set(approvedDetails?.selectedException + approvedDetails.selectedSubException, { exceptionType: approvedDetails?.selectedException, subExceptionType: approvedDetails.selectedSubException });
    //this.rootScope.activeCustTab['approvedExceptionIH'].set(approvedDetails?.selectedException ,approvedDetails.selectedSubException);

    if (this.rootScope.is_SecuredMap.get(this.rootScope.activeCustTab?.customerSessionId)) {

      const selectedSubExceptionData = this.rootScope?.subExceptionsList?.find(x => x?.exception_subtype_description == this.rootScope?.activeCustTab?.approvedExceptionsTypes?.selectedSubException);
      const exception_subtype = selectedSubExceptionData?.exception_subtype;

      if (exception_subtype != Constants.SECURITY_OVERRIDE_APPROVED_EXCEPTION) {
        this.updateTOSL4CallForApprovedException();

      } else {
        this.customerAlertService.expireAlert(() => this.updateTOSL4CallForApprovedException());
      }  
    } else {
      this.logger.debugLogs(Constants.AuthMethods.APE + ":PASS", this.className);
      this.rootScope.setAuthattempt({ "authMethod": Constants.AuthCode.APE, "result": "PASS" }); //CCR3-6188 to track
    }
    this.showPlatformInternalIdTable();

    this.logger.debugLogs("Approved Exception Continue clicked for customerSessionId: "+this.rootScope.activeCustTab.customerSessionId, this.className);

  }
 
   /** function used to check if dependent info is present in credetional details.
   * If Dependent info is present then return true else return false
   * @param elementkey 
   * @returns 
   */
  /*
  checkDependentInfoMsg(elementkey){
    if(elementkey?.indexOf(Constants.DEPENDENT_CREDS) != -1 && !this.rootScope.activeCustTab.approvedExceptionCredentialData.isDependentInfoMsgShown){
      this.rootScope.activeCustTab.approvedExceptionCredentialData.isDependentInfoMsgShown=true;
      return true;
    }  
    else{
      this.rootScope.activeCustTab.approvedExceptionCredentialData.isDependentInfoMsgShown=false;
      return false;
    }
    
    }
*/
    checkORTextApprovedException(elementkey){
      this.rootScope.activeCustTab.approvedExceptionCredentialData.isORText = false;
      if(this.rootScope.activeCustTab.approvedExceptionCredentialData?.prevkey?.includes(Constants.APPROVED_CREDS.NATIONAL) &&  elementkey?.includes(Constants.APPROVED_CREDS.BIRTH) && 
      this.rootScope?.activeCustTab?.approvedExceptionsTypes?.selectedException?.includes(Constants.APPROVED_CREDS.EXCEPTION_DEATH)
      && this.rootScope?.activeCustTab?.approvedExceptionsTypes?.selectedSubException?.includes(Constants.APPROVED_CREDS.SUBEXCEPTION_ACC_DEATH)
      ){
        /* istanbul ignore next */
        this.rootScope.activeCustTab.approvedExceptionCredentialData.prevkey = elementkey;
         
        this.rootScope.activeCustTab.approvedExceptionCredentialData.isORText =true;
       
        return true;
      }
      this.rootScope.activeCustTab.approvedExceptionCredentialData.prevkey = elementkey;
      return false;
    }

    checkforEmptyCredValues(values){
      //console.log('Values' + values);
       if (values?.length == 0){
          return true;
        }
        else if(values?.length >= 1 && (values[0]?.value == 'NA' || values[0]?.value == '')){
          return true;
        }
      
      return false;
    }

    /**
     * Function to check if Approved Exception cred field is label or not .
     * returns true is field is lable
     * expected value in stylekey column 'type:heading | ngClass:data-label-blue'
     * @param element 
     * @returns boolean
     */
     isCredsLabel(element): boolean {
      const styleKey = element?.stylekey?.toLowerCase();
      if (!styleKey || styleKey == "")  return false;

  
      const [typePart] = styleKey?.split('|');
      if (!typePart?.includes('type')) return false;
  
      const [, typeValue] = typePart.split(':');
      return typeValue?.trim()?.toLowerCase() === 'heading';
  }
     /**
     * Function to extract ngClass from the backend column.
     * returns classname to be set in NgClass
     * expected value in stylekey column 'type:heading | ngClass:data-label-blue'
     * @param element 
     * @returns class
     */
   
      getNgclass(element): string {
        const styleKey = element?.stylekey?.toLowerCase();
        if (!styleKey || !styleKey.includes('|')) return Constants.APPROVED_CREDS.DEFAULT_NGCLASS;
    
        const [, ngClassPart] = styleKey.split('|');
        if (!ngClassPart?.includes('ngclass')) return Constants.APPROVED_CREDS.DEFAULT_NGCLASS;
    
        const [, className] = ngClassPart.split(':');
        return className?.trim() || Constants.APPROVED_CREDS.DEFAULT_NGCLASS;
    }



  /**
   * Method to show message when no TBA resource links are configured 
   * CCR3-5977
   * @returns 
   */
  isApproveExceptionTBAConfigured() {
    if (
      this.rootScope.activeCustTab?.approvedExceptionsTypes?.selectedSubException
      && this.rootScope.activeCustTab?.isApprovedExceptionContinueClicked
    ) {
      let sellinkArray = this.rootScope.activeCustTab?.approvedExceptionResouceLinksData?.selectedResourceLinksData
      let filteredResource = sellinkArray?.filter(
        link => link?.heading == Constants.TBA_KC_ARTICLES_LINKS_TYPES.TBA_EVENTS || link?.heading == Constants.TBA_KC_ARTICLES_LINKS_TYPES.TBA_INQUIRIES
      )
      if (filteredResource?.length == 0)
        return true;
    }

    return false;

  }
  
  TbaLinkClick(subMenu){
    if (subMenu?.actionCode == 'LINK_ACTION') {
      const linkType = subMenu?.link?.linkType;
      const linkId = subMenu?.link?.linkId;
      const idMapping = this.rootScope.activeCustTab.tabData.tabData?.idMapping;
      console.log('TbaLinkClick-idMapping',idMapping);
      const isStandAlone = this.rootScope.activeCustTab.tabData.tabData?.idMapping
      .filter(x => x?.platformType?.includes('TBA'))?.length === 1;
       this.logger.debugLogs("TBA Link Clicked for customerSessionId: "+this.rootScope.activeCustTab.customerSessionId, this.className);
        if (linkType === Constants.LINK_TYPE.TBA && linkId != 'TBA-SYSTEM' && !isStandAlone) {

           /******* Below piece of code added to handle if idMapping have multiple entry of 
                     same domain Names but different Role Type.
                     It should be considered as single entry/ CCR1-10675 **********/
                     
            const filteredMappings = this.rootScope.activeCustTab.tabData.tabData?.idMapping.
                    filter(mapping => mapping.platformType.includes('TBA'));
                  
            let domainList = _.map(filteredMappings, item => item.domains);
            
            domainList = Array.from(new Set(domainList));  /**Remove duplicate values */
            /* istanbul ignore if */
            if (domainList?.length > 1)
              this.openDomainSelector(subMenu);  /** Open domain selector if multiple domains exist */
            else {
           
              this.rootScope.selectedLeftNavBarLink(subMenu, true);
            }
        } else {
          this.rootScope.selectedLeftNavBarLink(subMenu, true);
        }
      
    }
  }

  /**
   * Updates the TOSL4 call for the approved exception.
   * This method updates the security level, authentication status, icon class, and domain for the approved exception.
   * It also sets the CP_APPROVED_EXCPTION_SECURED attribute in the CallCustomerAttributes object.
   * Finally, it updates the CP_APPROVED_EXCPTION_SECURED attribute in the active customer tab's genesysAttributes.
   * This method calls the setAccountSecurityDt method of the ApiService to update the security payloads in Genesys and customer account tab values.
   */
  /* istanbul ignore next */
  updateTOSL4CallForApprovedException() {
    let model = { CS_SECURITY_LEVEL: Constants.securityLevels.SL4, authenticateStatus: Constants.FULLY_SECURED, iconClass: 'green', CP_APPROVED_EXCPTION_SECURED: true, domain: this.goToCustomerOveriew }
    let body: CallCustomerAttributes = {
      attributes: {
        CP_APPROVED_EXCPTION_SECURED: true,
        CS_AUTH_CD: Constants.AuthCode.APE
      },
    };
    this.rootScope.activeCustTab.genesysAttributes.CP_APPROVED_EXCPTION_SECURED = true;
    this.apiService.setAccountSecurityDt(model, body);//update security payloads in genesys and customer account tab values

  }

  /**
   * Determines whether to show the health coverage approved exception.
   * z
   * @returns A boolean value indicating whether to show the health coverage approved exception.
   */
  showHealthCoverageApprovedException(): boolean {
    const selectedSubExceptionData = this.rootScope?.subExceptionsList?.find(x => x?.exception_subtype_description == this.rootScope.activeCustTab?.approvedExceptionsTypes?.selectedSubException);

    if (this.rootScope.healthCardApprovedExceptionList.includes(selectedSubExceptionData?.exception_subtype) && this.rootScope.activeCustTab?.isApprovedExceptionContinueClicked) {
      return true;
    }
    return false;
  }

  /** CCR1-10121 */
  showPlatformInternalIdTable() {
    const selectedExceptedType =  this.rootScope.exceptionsList?.find(x => x?.exception_description == this.rootScope.activeCustTab?.approvedExceptionsTypes?.selectedException);
    const selectedSubExceptionData = this.rootScope.subExceptionsList?.find(x => x?.exception_subtype_description == this.rootScope.activeCustTab?.approvedExceptionsTypes?.selectedSubException);

    if(selectedExceptedType?.exception_type == Constants.AE_TYPE_GENERAL_INFO && selectedSubExceptionData?.exception_subtype == Constants.AE_SUBTYPE_PROVIDE_CUST_INTERNAL_ID) {
      this.rootScope.activeCustTab.platformTypeTableData.displayPlatformInternalIdTable = true;
    }
    else{
      this.rootScope.activeCustTab.platformTypeTableData.displayPlatformInternalIdTable = false;
    }
  } 

  /**CCR1-13978 */
  refreshAE(){
       this.rootScope.activeCustTab.approvedExceptionsTypes.exceptionTypeandSubTypeAPIFailure = false;
    this.rootScope.activeCustTab.approvedExceptionRefreshSuccessMsg = false;
    this.rootScope.activeCustTab.approvedExceptionsTypes.exceptionTypeandSubTypeAPIConfigMiss = false;
    this.rootScope.activeCustTab.approvedExceptionCredentialData.CredentialDataAPIConfigMiss = false;
    this.rootScope.activeCustTab.approvedExceptionCredentialData.CredentialDataAPIFailure = false;
    this.rootScope.activeCustTab.approvedExceptionEgainContentData.EgainContentConfigMiss = false;
    this.rootScope.activeCustTab.approvedExceptionEgainContentData.EgainContentAPIFailure = false;
    this.rootScope.activeCustTab.approvedExceptionResouceLinksData.resourceLinksAPIFailure = false;
    this.rootScope.activeCustTab.approvedExceptionResouceLinksData.resourceLinksConfigMiss = false;
    this.rootScope.exceptionsList = [];
    this.rootScope.subExceptionsList = [];
    this.rootScope.activeCustTab.approvedExceptionCredentialData.selectedCredentialData = [];
    this.rootScope.activeCustTab.approvedExceptionEgainContentData.selectedEgainContent = '';
    this.rootScope.activeCustTab.approvedExceptionResouceLinksData.selectedResourceLinksData = [];
    this.rootScope.activeCustTab.approvedExceptionsTypes.selectedSubException = '';
    this.rootScope.activeCustTab.approvedExceptionsTypes.selectedException = '';
    this.rootScope.approvedTypeExceptionForm.patchValue({
      type: '',
      subType: ''
    });
    this.customerAccountService.getApprovedExceptionsListByClientId(this.rootScope.activeCustTab.customerType,true);
    // this.rootScope.activeCustTab.approvedExceptionRefreshSuccessMsg = true;
    
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.logger.debugLogs("Approved Exception Page Refreshed for customerSessionId: "+this.rootScope.activeCustTab.customerSessionId, this.className);
  }

}